import React from 'react'
import Button from '@material-ui/core/Button';
import piechart from '../assets/piechart.png'
import linegraph from '../assets/linegraph.png'

export default function Analytics(props) {
    const toHome = () => {
        props.history.push("/home")
      }
    return (
        <div className="Analytics" >
            <h1>Analytics</h1>
            <h2>Check your Macros</h2>
                <img src={piechart}/>
            <h2>Check your Spending</h2>
                <img src={linegraph}/>
            <ul>
                <Button variant="contained" onClick={toHome}> <i className="material-icons"> home </i> Home</Button>
            </ul>
        </div>
    )
}
